import './App.css';
import Chrome from './images/logo-chrome.svg';
import Firefox from './images/logo-firefox.svg';
import Opera from './images/logo-opera.svg';
import Dots from './images/bg-dots.svg'

const Extension = () => {
    return (
        <section>
            <div className='top-section'>
                <h1 style={{ fontSize: '2rem', marginBottom: '10px' }}>Download the extension</h1>
                <p>We’ve got more browsers in the pipeline. Please do let us know if you’ve 
                got a favourite you’d like us to prioritize.</p>
     </div>
     <div className='main-div'>
        <div className='inner-div'>
            <img src={Chrome} alt="Chrome-logo" />
            <h1 style={{ fontSize: '25px' }}>Add to Chrome</h1>
            <p>Minimum version 62</p>
            <img src={Dots} alt="Dots" />

            <button>Add & Install Extension</button>
        </div>

        <div className='inner-div'>
            <img src={Firefox} alt="Firefox-logo" />
            <h1 style={{ fontSize: '25px' }}>Add to Firefox</h1>
            <p>Minimum version 55</p>
            <img src={Dots} alt="Dots" />

            <button>Add & Install Extension</button>
        </div>

        <div className='inner-div'>
            <img src={Opera} alt="Opera-logo" />
            <h1 style={{ fontSize: '25px' }}>Add to Opera</h1>
            <p>Minimum version 46</p>
            <img src={Dots} alt="Dots" />

            <button>Add & Install Extension</button>
        </div>
     </div>
        </section>
    );
    
}

export default Extension;